(() => {
    if (window.bestsellerSearchInitialized) return;
    window.bestsellerSearchInitialized = true;

    const input = document.querySelector('#drawer-search-input');
    const bestseller = document.querySelector('#predictive-search-bestseller');
    const predictive = document.querySelector('#predictive-search');
    const clearButton = document.querySelector('.drawer-search__input--clear');
    let hideUntilUpdate = false;
    let suggestFailed = false;
    let suggestGeneration = 0;

    // Predictive search builds `?q=` + term + `&resources[` without encoding.
    // URLSearchParams would turn "+" into a space and cut the term at "&" or "#".
    function queryFromSuggestUrl(url) {
        const key = 'q=';
        const queryStart = url.indexOf('?' + key);
        const ampStart = url.indexOf('&' + key);
        const at = queryStart !== -1 ? queryStart + 1 : ampStart;
        if (at === -1) return null;
        const valueStart = at + key.length;
        const marker = '&resources[';
        const end = url.indexOf(marker, valueStart);
        return end === -1 ? url.slice(valueStart) : url.slice(valueStart, end);
    }

    function currentQuery() {
        return input ? input.value.trim() : '';
    }

    function matchesLiveQuery(requested, generation) {
        if (generation !== suggestGeneration) return false;
        if (requested === null) return true;
        return requested === currentQuery();
    }

    const originalFetch = window.fetch.bind(window);
    window.fetch = function (inputArg, init) {
        const url = typeof inputArg === 'string' ? inputArg : (inputArg && inputArg.url) || '';
        if (!url.includes('/search/suggest')) {
            return originalFetch(inputArg, init);
        }

        const requested = queryFromSuggestUrl(url);
        const generation = suggestGeneration;

        return originalFetch(inputArg, init).then((response) => {
            if (!matchesLiveQuery(requested, generation)) {
                return new Promise(() => {});
            }
            if (!response.ok) {
                recoverFromSuggestError();
            } else {
                suggestFailed = false;
            }
            return response;
        }, (error) => {
            if (!matchesLiveQuery(requested, generation)) {
                return new Promise(() => {});
            }
            recoverFromSuggestError();
            return Promise.reject(error);
        });
    };

    function hasTypedQuery() {
        return Boolean(input && input.value.trim());
    }

    function hasZeroProductResults() {
        return Boolean(predictive && predictive.querySelector('.bs-search-empty'));
    }

    function recoverFromSuggestError() {
        suggestFailed = true;
        hideUntilUpdate = false;
        toggleSearch();
    }

    function toggleSearch() {
        if (!input || !bestseller) return;

        const emptyQuery = !hasTypedQuery();
        const showPopular = emptyQuery || (!hideUntilUpdate && (suggestFailed || hasZeroProductResults()));

        bestseller.classList.toggle('is-hidden', !showPopular);

        if (emptyQuery) {
            hideUntilUpdate = false;
            suggestFailed = false;
            // <predictive-search> writes display inline, so only an inline
            // value can hide leftover results from a previous query.
            if (predictive) predictive.style.display = 'none';
            clearButton?.classList.add('is-hidden');
        } else if (hideUntilUpdate || suggestFailed) {
            if (predictive) predictive.style.display = 'none';
            clearButton?.classList.remove('is-hidden');
        } else {
            if (predictive) predictive.style.display = '';
            clearButton?.classList.remove('is-hidden');
        }

        if (showPopular) {
            if (window.initSearchSliders) window.initSearchSliders();
            if (window.initProductCardSliders && !bestseller.dataset.swiperInitialized) {
                window.initProductCardSliders();
                bestseller.dataset.swiperInitialized = 'true';
            }
        }
    }

    if (input) {
        toggleSearch();
        input.addEventListener('input', () => {
            suggestGeneration += 1;
            suggestFailed = false;
            hideUntilUpdate = hasTypedQuery();
            toggleSearch();
        });
        input.addEventListener('keyup', toggleSearch);

        if (clearButton) {
            clearButton.addEventListener('click', () => {
                setTimeout(toggleSearch, 0);
            });
        }

        if (predictive) {
            new MutationObserver(() => {
                hideUntilUpdate = false;
                toggleSearch();
            }).observe(predictive, {
                childList: true,
                subtree: true
            });
        }

        const originalOpen = window.openSearchDrawer;
        if (typeof originalOpen === 'function') {
            window.openSearchDrawer = function () {
                originalOpen.apply(this, arguments);
                toggleSearch();
            };
        }
    }
})();
